var render = function () {
  var _vm$meeting;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-12 mb-lg-20"
  }, [_vm._v(" " + _vm._s(((_vm$meeting = _vm.meeting) === null || _vm$meeting === void 0 ? void 0 : _vm$meeting.title) || "") + " ")]), _c('div', {
    staticClass: "schedule-items"
  }, _vm._l(_vm.dates, function (date) {
    return _c('div', {
      key: date.text,
      staticClass: "schedule-item"
    }, [_c('p', {
      staticClass: "page-text--lg font-weight-medium mb-8 mb-lg-16"
    }, [_vm._v(" " + _vm._s(date.text) + " ")]), _c('v-row', {
      staticClass: "row--small"
    }, _vm._l(date.times, function (time) {
      return _c('v-col', {
        key: "".concat(date.text, " ").concat(time.text),
        attrs: {
          "cols": "4",
          "md": "3",
          "lg": "2"
        }
      }, [_c('v-btn', _vm._g({
        class: time.isActive ? '' : 'grey-6--text',
        attrs: {
          "block": "",
          "outlined": "",
          "color": time.isActive ? 'primary' : 'grey-9',
          "elevation": time.isActive ? 1 : undefined
        }
      }, _vm.toggle(time)), [_c('v-row', {
        attrs: {
          "no-gutters": "",
          "align": "center"
        }
      }, [_c('v-col', {
        staticClass: "text-start"
      }, [_vm._v(" " + _vm._s(time.text) + " ")]), _vm.mode == 'form' ? _c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_c('v-simple-checkbox', _vm._g({
        attrs: {
          "value": time.isActive,
          "color": "primary"
        }
      }, _vm.toggle(time)))], 1) : _vm._e()], 1)], 1)], 1);
    }), 1)], 1);
  }), 0)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }